"use strict";class CustomVideoSlideshow extends HTMLElement{constructor(){var t,e;super(),(this.element=this).actionButton=this.querySelector(".j-actionButton")&&this.querySelector(".j-actionButton"),this.actionButton.addEventListener("click",()=>{this.setChangePlay()}),this.iconPlay=this.querySelector(".j-iconButtonPlay"),this.iconPause=this.querySelector(".j-iconButtonPause"),this.video=this.querySelector(".j-customVideo"),this.videoProduct=this.querySelector(".j-customVideoProduct"),this.isPlaying(),window.innerWidth<750&&(t=this.video.dataset.videoMobile,e=this.video.querySelector(".j-sourceVideo"),t?(e.src=t,this.video.load(),this.video.addEventListener("loadeddata",function(){this.play()})):this.video.closest(".j-wrapperCustomVideo").classList.add("slideshow__videoWrapper--hideMobile"))}isPlaying(){this.video.autoplay?this.setPauseButton():this.setPlayButton()}setPauseButton(){this.iconPlay.classList.add("hidden"),this.iconPause.classList.remove("hidden")}setPlayButton(){this.iconPlay.classList.remove("hidden"),this.iconPause.classList.add("hidden")}setChangePlay(){this.video.paused?(this.video.play(),this.setPauseButton()):(this.video.pause(),this.setPlayButton())}}customElements.define("custom-video-slideshow",CustomVideoSlideshow);
// Aggiungi questo codice al file assets/custom-video-slideshow.js

// Funzione per correggere l'accessibilità del slideshow
function fixSlideshowAccessibility() {
  const slideshows = document.querySelectorAll('slideshow-component');
  
  slideshows.forEach(slideshow => {
    // Trova tutti gli slide con aria-hidden="true"
    const hiddenSlides = slideshow.querySelectorAll('.slideshow__slide[aria-hidden="true"]');
    
    hiddenSlides.forEach(slide => {
      // Trova tutti i link con classe slideshow__link
      const links = slide.querySelectorAll('a.slideshow__link[href]');
      
      links.forEach(link => {
        // Salva l'href originale se non già salvato
        if (!link.hasAttribute('data-original-href')) {
          link.setAttribute('data-original-href', link.getAttribute('href'));
        }
        
        // Rimuovi href per renderlo non focusabile
        link.removeAttribute('href');
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
        
        // Previeni interazioni
        link.style.pointerEvents = 'none';
        link.style.cursor = 'default';
      });
    });
    
    // Ripristina per slide visibili
    const visibleSlides = slideshow.querySelectorAll('.slideshow__slide:not([aria-hidden="true"])');
    
    visibleSlides.forEach(slide => {
      const links = slide.querySelectorAll('a.slideshow__link[data-original-href]');
      
      links.forEach(link => {
        const originalHref = link.getAttribute('data-original-href');
        if (originalHref) {
          link.setAttribute('href', originalHref);
          link.removeAttribute('tabindex');
          link.removeAttribute('aria-hidden');
          link.style.pointerEvents = '';
          link.style.cursor = '';
        }
      });
    });
  });
}

// Inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', function() {
  // Aspetta che Flickity si inizializzi
  setTimeout(fixSlideshowAccessibility, 200);
  
  // Observer per monitorare i cambiamenti di aria-hidden
  const observer = new MutationObserver(function(mutations) {
    let needsFix = false;
    
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'aria-hidden' &&
          mutation.target.classList.contains('slideshow__slide')) {
        needsFix = true;
      }
    });
    
    if (needsFix) {
      setTimeout(fixSlideshowAccessibility, 10);
    }
  });
  
  // Osserva tutti i slideshow
  const slideshows = document.querySelectorAll('slideshow-component');
  slideshows.forEach(slideshow => {
    observer.observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
    
    // Gestisci click sui controlli Flickity
    slideshow.addEventListener('click', function(e) {
      if (e.target.closest('.flickity-button') || 
          e.target.closest('.flickity-page-dot')) {
        setTimeout(fixSlideshowAccessibility, 50);
      }
    });
  });
  
  // Controllo periodico iniziale
  let checks = 0;
  const periodicCheck = setInterval(() => {
    fixSlideshowAccessibility();
    checks++;
    
    if (checks >= 3) {
      clearInterval(periodicCheck);
    }
  }, 1000);
});

// CSS per forzare la rimozione delle interazioni (se possibile aggiungere al CSS)
// Altrimenti aggiungi questo a section-slideshow.css:
/*
.slideshow__slide[aria-hidden="true"] .slideshow__link {
  pointer-events: none !important;
  cursor: default !important;
}
*/